module.exports = __webpack_public_path__ + "static/img/kechuang.9851364.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kechuang.png
// module id = 4cR5
// module chunks = 1